var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFounderCommunity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.7148 33.7463H29.4913H8.50711H0V38H37.7148V33.7463Z",
    fill: "#00ADEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7302 17.0145H31.4766V29.4918H35.7302V17.0145Z",
    fill: "#00ADEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4919 12.7608H37.7154V9.35796L19.8505 0.283591C19.567 1.73038e-05 19.2833 0 18.9998 0C18.7162 0 18.4327 1.73038e-05 18.1491 0.283591L0.28418 9.35796V12.7608H29.4919Z",
    fill: "#00ADEF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2224 17.0145H10.4917V29.4918H27.2224V17.0145Z",
    fill: "#00ADEF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5221 17.0145H2.26855V29.4918H6.5221V17.0145Z",
    fill: "#00ADEF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFounderCommunity);
export default __webpack_public_path__ + "static/media/founderCommunity.943ee4752f8d2c9b03fcfadb35f8f91f.svg";
export { ForwardRef as ReactComponent };